import React, { useState } from 'react';
import constants from './Constants/constants';
const UserContext = React.createContext();

function ContextProvider(props) {
	localStorage.setItem('surveyUrl', window.location.search || '');
	const [collapsed, setCollapsed] = useState(false);
	const [profileImage, setProfileImage] = useState('');
	// Derived identity and permissions from /check-permission, refilled every page load.
	const [session, setSession] = useState({});
	const [clearanceTabTitle, setClearanceTabTitle] = useState(constants.InitialHealth);
	const [clearanceTabKey, setClearanceTabKey] = useState('initial-health');
	const [showFloater, setShowFloater] = useState(sessionStorage.getItem("showFloater") || 'hide');
	const [selectedMenuItem, setSelectedMenuItem] = useState(sessionStorage.getItem("selectedMenuItem") || 'dashboard');
  const [selectedSubMenuItem, setSelectedSubMenuItem] = useState(sessionStorage.getItem("selectedSubMenuItem") || '');
  const [breadcrumbItems, setBreadcrumbItems] = useState(sessionStorage.getItem("breadcrumbItems") ? JSON.parse(sessionStorage.getItem("breadcrumbItems")) : []);

	const toggleCollapsed = () => setCollapsed(prev => !prev)

	let contextProps = {
		collapsed,
		toggleCollapsed,
		profileImage,
		setProfileImage,
		session,
		setSession,
		clearanceTabTitle,
		setClearanceTabTitle,
		clearanceTabKey,
		setClearanceTabKey,
		showFloater,
		setShowFloater,
		selectedMenuItem,
		setSelectedMenuItem,
		selectedSubMenuItem,
		setSelectedSubMenuItem,
		breadcrumbItems,
		setBreadcrumbItems
	}

	return (
		<UserContext.Provider value={{ ...contextProps }}>
			{props.children}
		</UserContext.Provider>
	)
}
export { ContextProvider, UserContext }
